<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :has0-month="true" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateChangeForGraph3">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph3(button.dataType)">{{ button.label }}</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>

    <!-- 그래프 4-->
    <vs-col class="w-full pb-4">
      <monthly-comparison-card :title="graph4.title" :year="graph4.year" :month="graph4.month" :unit="graph4.unit" :heads="graph4.heads" :list="graph4.list" :getCol="getColForGraph4" @change="dateChangeForGraph4">
        <template slot="tools">
          <div>
            <vs-select class="w-full lg:w-48" autocomplete v-model="graph4.dataType1" @change="dataType1ChangeForGraph4">
              <vs-select-item value="부서" text="부서별" />
              <vs-select-item value="사업장" text="사업장별" />
            </vs-select>
          </div>
          <vs-button class="py-3 px-0 lg:px-8" type="border"
                     :color="graph4.dataType2 === '구분' ? 'primary' : 'secondary'"
                     @click="dataType2ChangeForGraph4('구분')">구분</vs-button>
          <vs-button class="py-3 px-0 lg:px-8" type="border"
                     :color="graph4.dataType2 === '구분_직종' ? 'primary' : 'secondary'"
                     @click="dataType2ChangeForGraph4('구분_직종')">구분+직종</vs-button>
        </template>
      </monthly-comparison-card>
    </vs-col>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyChartCard2 from "@/views/graph-detail/components/MonthlyChartCard2";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
import tabItems from "@/views/boards/tab/tab-items";

export default {
  name: "GraphDetail02",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard2,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    isApproval() {
      return tabItems[358].isApproval;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1;  // LEVEL
          }
        }
      }
      return 4;
    },
    getButtons() {
      switch (this.getLevel) {
      case 1:
        return [
          { label: '부서(국)', dataType: 'company1' },
          { label: '부서(과)', dataType: 'company2' },
          { label: '종사자 현황', dataType: 'employee_status' },
          { label: '종사자 구분', dataType: 'employee_type' },
        ]
      case 2:
        return [
          { label: '부서(국)', dataType: 'company0' },
          { label: '부서(과)', dataType: 'company1' },
          { label: '종사자 현황', dataType: 'employee_status' },
          { label: '종사자 구분', dataType: 'employee_type' },
        ]
      case 3:
        return [
          { label: '부서(과)', dataType: 'company0' },
          { label: '종사자 현황', dataType: 'employee_status' },
          { label: '종사자 구분', dataType: 'employee_type' },
        ]
      case 4:
        return [
          { label: '종사자 현황', dataType: 'employee_status' },
          { label: '종사자 구분', dataType: 'employee_type' },
        ]
      }
    }
  },
  data() {
    return {
      boardId: 358,
      summaryKey: ["종사자_직종", "sum"],
      boardIds: [299, 358],
      summaryKeys: {
        'detail' : ['종사자현황_구분', 'sum'],
        'detail_직종' : ['종사자현황_직종', 'sum'],
        'field' : ['종사자현황_사업장', 'sum'],
        'address' : ['종사자현황_부서', 'sum'],
        'field_cat1' : ['종사자현황_부서', 'sum'],
        'company' : ['종사자현황_부서', 'sum'],
        'project' : ['종사자현황_부서', 'sum'],
      },
      buttons: [
        { label: '부서(업체)', dataType: 'company' },
        { label: '사업장', dataType: 'field' },
        { label: '종사자 구분', dataType: 'detail' },
        { label: '직종', dataType: 'detail_직종' },
      ],
      graph1: {
        title: "종사자 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: 0,
        unit: "",
        heads: [{ name: "No." }, { name: "부서(업체)" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType: "company1",
        depth: 1,
      },
      graph3: {
        title: "기간별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        list: [],
        dataType: "company",
        depth: 1,
      },
      graph4: {
        title: "상세 내부종사자 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType1: "부서",
        dataType2: "구분",
      },
      cache: {},
      loading: false,
    };
  },
  async mounted() {
    await this.loadDetailData();

    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;
    this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
    await this.loadGraph4();
  },

  methods: {
    // API에서 상세 정보를 불러온다
    async loadDetailData(currentYear, depth = -1) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (depth < 0) {
        depth = 1;
      }

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[`detail_${currentYear}_${depth}`]) {
        return this.cache[`detail_${currentYear}_${depth}`];
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectIds: [this.projectId],
          depth
        };

        this.$vs.loading();
        this.loading = true;
        try {
          const data = await this.$store.dispatch("summary/LOAD_DONUT_02_DETAIL", params);
          this.$vs.loading.close();
          this.loading = false;
          this.cache[`detail_${currentYear}_${depth}`] = data;
          return data;
        } catch (e) {
          this.$vs.loading.close();
          this.loading = false;
          this.$vs.notify({title: "Error", text: "데이터를 불러오는데 실패했습니다.", color: "danger"});
        }
      }
    },


    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);
      const graph1Data = data.monthly;
      const currentYear = graph1Data[yyyy] ? graph1Data[yyyy] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const prevYear = graph1Data[yyyy - 1] ? graph1Data[yyyy - 1] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      // 첫번째 배열은 총 합이므로, 데이터에서 제외한다
      currentYear.shift();
      prevYear.shift();

      this.graph1.data1 = currentYear;
      this.graph1.data2 = prevYear;
      this.graph1.sum1 = `${prevYear[prevYear.length - 1]}`;
      this.graph1.sum2 = `${currentYear[currentYear.length - 1]}`;
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      let depth = 1;
      if (this.graph2.dataType === 'company0') {
        depth = 0;
      } else if (this.graph2.dataType === 'company1') {
        depth = 1;
      } else if (this.graph2.dataType === 'company2') {
        depth = 2;
      }

      const data = await this.loadDetailData(yyyy, depth)
      console.log({yyyy, depth})
      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "employee_status":
        graph2Data = data.employee_status;
        break;
      case "employee_type":
        graph2Data = data.employee_type;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph2.month;
      const prevYear = currentMonth <= 1 ? currentYear - 1 : currentYear;
      let prevMonth = 0;
      if (currentMonth === 0) {
        prevMonth = 0;
      } else if (currentMonth === 1) {
        prevMonth = 12;
      } else {
        prevMonth = currentMonth - 1;
      }

      const currentData = graph2Data[currentYear][currentMonth];
      const prevData = graph2Data[prevYear][prevMonth];


      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          name: row.label,
          value: row.count,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            name: row.label,
            value: 0,
            gap: -row.count,
          });
          no += 1;
        }
      }

      this.graph2.list = list;
    },

    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) {
        return new Intl.NumberFormat().format(value.value);
      }
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
      }
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = label
      if (this.projectId) {
        this.graph2.dataType = dataType;
        if (dataType === 'company1') {
          this.graph2.depth = 1;
        }
        else if (dataType === 'company2') {
          this.graph2.depth = 2;
        } else {
          this.graph2.depth = 1;
        }
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      let depth = 1;
      if (this.graph3.dataType === 'company0') {
        depth = 0;
      } else if (this.graph3.dataType === 'company1') {
        depth = 1;
      } else if (this.graph3.dataType === 'company2') {
        depth = 2;
      }

      const data = await this.loadDetailData(yyyy, depth)
      let graph2Data = [];
      switch (this.graph3.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "employee_type":
        graph2Data = data.employee_type;
        break;
      case "employee_status":
        graph2Data = data.employee_status;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph3.month;
      const currentData = graph2Data[currentYear][currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.count,
        });
      }

      this.graph3.list = list;
    },

    dateChangeForGraph3(beginDate, endDate) {
      this.graph3.beginDate = beginDate;
      this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        if (dataType === 'company1') {
          this.graph3.depth = 1;
        }
        else if (dataType === 'company2') {
          this.graph3.depth = 2;
        } else {
          this.graph3.depth = 1;
        }

        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },

    // 그래프 4
    async loadGraph4() {
      const yyyy = this.graph4.year;
      const depth = this.graph4.depth;

      const data = await this.loadDetailData(yyyy, depth)
      let graph4Data = [];
      switch (this.graph4.dataType1) {
      case "부서":
        if (this.graph4.dataType2 === "구분") {
          graph4Data = data.company_employee;
        } else {
          graph4Data = data.company_employee_job_title;
        }
        break;
      case "사업장":
        if (this.graph4.dataType2 === "구분") {
          graph4Data = data.field_employee;
        } else {
          graph4Data = data.field_employee_job_title;
        }
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph4.month;
      const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph4Data[currentYear][currentMonth];
      const prevData = graph4Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          "name": row.label,
          "value": row.count,
          '구분': row.employee_type,
          '직종': row.job_title,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            "name": row.label,
            "value": 0,
            "gap": -row.count,
            '구분': row.employee_type,
            '직종': row.job_title,
          });
          no += 1;
        }
      }

      this.graph4.list = list;
    },

    getColForGraph4(index, value) {
      if (this.graph4.dataType2 === '구분') {
        if (index === 0) return value.no;
        if (index === 1) return value.name;
        if (index === 2) return value.구분;
        if (index === 3) return value.value;
        if (index === 4) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
        }
      }

      if (this.graph4.dataType2 === '구분_직종') {
        if (index === 0) return value.no;
        if (index === 1) return value.name;
        if (index === 2) return value.구분;
        if (index === 3) return value.직종;
        if (index === 4) return value.value;
        if (index === 5) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
        }
      }

      return "";
    },
    dateChangeForGraph4(year, month) {
      this.graph4.year = year;
      this.graph4.month = month;
      this.loadGraph4();
    },
    dataType1ChangeForGraph4() {
      if (this.graph4.dataType2 === "구분") {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }];
      } else {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "직종" }, { name: "명" }, { name: "전월대비 증감" }];
      }
      this.loadGraph4();
    },
    dataType2ChangeForGraph4(dataType) {
      this.graph4.dataType2 = dataType;
      this.dataType1ChangeForGraph4();
    },
  },
};
</script>

<style scoped></style>
